

import React, { useState } from 'react';
// import các component UI của bạn (Input, Select, Button...)
// import hook useCategories để lấy danh sách danh mục
import { useCategories } from '../../../../hooks/category/useCategories';
import './CreateListingForm.css';

const CreateListingForm = ({ onSuccess }) => {
    // 1. STATE ĐỂ LẤY DỮ LIỆU CHO CÁC DROPDOWN
    const { categories, loading: categoriesLoading } = useCategories();
    // Giả sử bạn có hook tương tự để lấy danh sách tỉnh/thành...
    // const { provinces } = useLocations(); 

    // 2. STATE CHO CÁC TRƯỜNG CỦA FORM
    const [images, setImages] = useState([]);
    const [video, setVideo] = useState(null);
    const [categoryId, setCategoryId] = useState('');
    const [title, setTitle] = useState('');
    const [price, setPrice] = useState('');
    const [description, setDescription] = useState(
        // Gợi ý mẫu cho người dùng
        '- Tình trạng sản phẩm\n- Thương hiệu, model\n- Phụ kiện đi kèm\n- Bảo hành (nếu có)\n- Địa chỉ giao hàng\n- Thông tin liên hệ'
    );
    const [address, setAddress] = useState('');
    const [provinceId, setProvinceId] = useState('');
    // ... state cho district và ward

    // 3. STATE CHO VIỆC SUBMIT
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [errors, setErrors] = useState({});

    // 4. HÀM XỬ LÝ SUBMIT
    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        
        // --- Validation đơn giản ---
        const newErrors = {};
        if (images.length === 0) newErrors.images = "Vui lòng đăng ít nhất 1 ảnh sản phẩm.";
        if (!categoryId) newErrors.categoryId = "Vui lòng chọn danh mục sản phẩm.";
        if (!title) newErrors.title = "Vui lòng nhập tên sản phẩm.";
        // ... các validation khác
        setErrors(newErrors);
        
        if (Object.keys(newErrors).length > 0) {
            setIsSubmitting(false);
            return;
        }

        // --- Gói dữ liệu để gửi lên API ---
        const formData = new FormData(); // Dùng FormData để gửi file
        images.forEach(img => formData.append('images', img.file));
        // formData.append('video', video.file);
        formData.append('CategoryID', categoryId);
        formData.append('title', title);
        formData.append('price', price);
        formData.append('description', description);
        formData.append('Address', address);
        formData.append('ProvinceID', provinceId);
        
        try {
            // Gọi API để đăng tin
            // await createListingAPI(formData);
            alert('Đăng tin sản phẩm thành công!');
            // Gọi callback để đóng modal
            if (onSuccess) {
                onSuccess();
            }
        } catch (error) {
            alert('Đăng tin thất bại, vui lòng thử lại.');
        } finally {
            setIsSubmitting(false);
        }
    };

   // Tiếp tục trong component CreateListingForm

  return (
    <form className="create-listing-form" onSubmit={handleSubmit}>
      <h2>Đăng tin sản phẩm</h2>
      
      {/* --- PHẦN HÌNH ẢNH & VIDEO --- */}
      <div className="form-section">
        <h3>Hình ảnh và video sản phẩm</h3>
        <div className="upload-area">
          <div className="image-upload-box">
            <span>📷</span>
            <p>Đăng từ 1 đến 5 ảnh sản phẩm</p>
            <input type="file" multiple onChange={(e) => setImages([...e.target.files])} />
            {errors.images && <p className="error-text">{errors.images}</p>}
          </div>
          <div className="video-upload-box">
            <span>📹</span>
            <p>Đăng video sản phẩm</p>
            <input type="file" onChange={(e) => setVideo(e.target.files[0])} />
          </div>
        </div>
      </div>

      {/* --- PHẦN THÔNG TIN CHI TIẾT --- */}
      <div className="form-section">
        <h3>Thông tin chi tiết</h3>
        <div className="form-field">
          <label htmlFor="category">Danh mục sản phẩm *</label>
          <select id="category" value={categoryId} onChange={(e) => setCategoryId(e.target.value)}>
            <option value="">-- Chọn danh mục --</option>
            <option value="1">Điện tử - Công nghệ</option>
            <option value="2">Thời trang</option>
            <option value="3">Nhà cửa - Đời sống</option>
            <option value="4">Xe cộ</option>
            <option value="5">Thể thao - Du lịch</option>
            <option value="6">Sách - Văn phòng phẩm</option>
            <option value="7">Mẹ và bé</option>
            <option value="8">Làm đẹp - Sức khỏe</option>
            <option value="9">Thú cưng</option>
            <option value="10">Khác</option>
          </select>
          {errors.categoryId && <p className="error-text">{errors.categoryId}</p>}
        </div>

        <div className="form-field">
            <label htmlFor="title">Tên sản phẩm *</label>
            <input type="text" id="title" value={title} placeholder="VD: iPhone 13 Pro Max 128GB" onChange={(e) => setTitle(e.target.value)} />
            {errors.title && <p className="error-text">{errors.title}</p>}
        </div>
        
        <div className="form-field">
            <label htmlFor="price">Giá bán (VNĐ) *</label>
            <input type="number" id="price" value={price} placeholder="VD: 15000000" onChange={(e) => setPrice(e.target.value)} />
        </div>
        
        <div className="form-field">
            <label htmlFor="description">Mô tả chi tiết *</label>
            <textarea id="description" rows="10" value={description} placeholder="- Tình trạng sản phẩm&#10;- Thương hiệu, model&#10;- Phụ kiện đi kèm&#10;- Bảo hành (nếu có)&#10;- Địa chỉ giao hàng&#10;- Thông tin liên hệ" onChange={(e) => setDescription(e.target.value)}></textarea>
        </div>
        
        <div className="form-field">
            <label htmlFor="address">Địa chỉ *</label>
            <input type="text" id="address" value={address} placeholder="VD: Hà Nội, TP.HCM..." onChange={(e) => setAddress(e.target.value)} />
        </div>
      </div>

      <button type="submit" className="submit-btn" disabled={isSubmitting}>
        {isSubmitting ? 'Đang đăng...' : 'Đăng tin sản phẩm'}
      </button>
    </form>
  );
};
export default CreateListingForm;